import React from "react";
import { useLocation } from "react-router-dom";
import "./Order_id_holder.css";
import { faCircleDown } from "@fortawesome/free-solid-svg-icons";
// import Return_Lottie from "../../../Animation/return_Lottie/Return_Lottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDate } from "../../../../utils/common";

function Order_id_holder({
  delivery,
  order,
  date,
  headingText,
  subText,
  reason,
}) {
  const location = useLocation();
  const isReturnPage = location.pathname === "/return-order-details";

  const formatTime12Hour = (time) => {
    if (!time) return "";
    const [hour, minute] = time.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // const handleDownloadInvoice = (invoicePath) => {
  //   if (!invoicePath) {
  //     alert("Invoice not available");
  //     return;
  //   }

  //   const fileUrl = `${process.env.REACT_APP_IMG_URL}${invoicePath}`;

  //   window.open(fileUrl, "_blank");
  // };

  const handleDownloadInvoice = async (invoicePath) => {
  if (!invoicePath) {
    alert("Invoice not available");
    return;
  }

  try {
    const fileUrl = `${process.env.REACT_APP_IMG_URL}${invoicePath}`;

    // Fetch the file as blob
    const response = await fetch(fileUrl, { mode: "cors" });
    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();

    // Create a temporary object URL from blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "dportInvoice.pdf"); // you can make this dynamic
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed:", error);
    alert("Failed to download invoice");
  }
};


  return (
    <>
      <section className="Order_id_holder">
        <div className="order_id mb-3">
          <div className="img_id_holder">
            {!isReturnPage && (
              <div>
                <div className="img_holder">
                  <img
                    className="Product_img"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/logo.png"
                    }
                    alt="Product_img"
                  />
                </div>
              </div>
            )}

            {isReturnPage && (
              <div className="animation_holder">{/* <Return_Lottie /> */}</div>
            )}

            <div className="ms-3">
              <h2>{headingText}</h2>
              <p className="sub_text">{subText}</p>
            </div>
          </div>
          <p>{date}</p>
        </div>

        {!delivery && (
          <>
            {" "}
            <div className="ms-2">
              <h6 className="odh6">
                Selected Delivery Date:{" "}
                <span className="small">
                  {formatDate(order?.delivery_date)}
                </span>
              </h6>
            </div>
            <div className="ms-2">
              <h6 className="odh6">
                Selected Delivery Time:
                <span className="small">
                  {formatTime12Hour(order?.Time_Slot?.from)}-
                  {formatTime12Hour(order?.Time_Slot?.to)}
                </span>
              </h6>
            </div>
            <div className="ms-2">
              <button
                className="download_btn"
                onClick={() => handleDownloadInvoice(order?.invoice)}
              >
                Download Invoice <FontAwesomeIcon icon={faCircleDown} />
              </button>
            </div>
          </>
        )}

        {reason && (
          <p>
            <span>
              <b>Cancel Reason : </b>
            </span>
            {reason}
          </p>
        )}
      </section>
    </>
  );
}

export default Order_id_holder;
